import { Module } from "wrapper6";

var $ = jQuery;

var gInfowindow;
var gLocations = [];
var gMap = false;
var gMarkers = [];
var lastMapUpdate = 0;

var last_map_update = 0;

export default class PickupPointPicker extends Module {

	ready(app) {
		/*gInfowindow = new google.maps.InfoWindow();

		google.maps.Map.prototype.clearMarkers = function() {
			for(var i=0; i < gMarkers.length; i++){
				gMarkers[i].setMap(null);
			}
			gMarkers = [];
		};*/


		this.registerEvents();
	}

	registerEvents() {
		var self = this;

		$(document.body).on('update_checkout', function() {
			self.updatePickupPoints();
		});

		$(document).on('change', 'input[name=gls_parcelshop_radio]', function() {
			self.updateSelectedPickupPoint($(this));
		});

		// MODAL
		$(document).on('click', '.open-shipping-modal', function(e) {
			e.preventDefault();

			self.openModal();
		});
	}

	openModal() {
		var address = this.getShippinAddress();

		$('#shipping-modal input#country').val(address.country);
		$('#shipping-modal input#zipcode').val(address.zipcode);
		$('#shipping-modal input#address').val(address.address);

		anime({
			targets: '#shipping-modal .modal-inner',
			opacity: [0, 1],
			translateY: [-30, 0],
			duration: 300,
			easing: 'easeOutCubic',
			delay: 200
		});

		this.checkGoogleMapsSearchButtonStatus();

		$('body').addClass('modal-open');
		$('#shipping-modal').addClass('active');

		this.updateMapsPickupPoints(true);
	}

	updateMapsPickupPoints(delayed_timeout) {
		var delay = 1;
		var now = (new Date).valueOf() / 1000;

		var self = this;

		if(now - delay > last_map_update) {
			last_map_update = now;

			var address = $('#shipping-modal input#address').val();
			var zipcode = $('#shipping-modal input#zipcode').val();

			if(
				address !== undefined &&
				address !== null &&
				address.length > 0 &&
				zipcode !== undefined &&
				zipcode !== null &&
				zipcode.length === 4
			) {
				var original_address = this.getShippinAddress();
				var data = {
					action: 'get_pickup_points_for_modal',
					country: original_address.country,
					zipcode: zipcode,
					address: address
				};

				$.post(main_theme_objects.ajax_url, data, function (response) {
					if (response.hasOwnProperty('success') && response.success) {
						gLocations = [];

						for (var id in response.data.shops) {
							gLocations.push({
								address: response.data.shops[id].streetname,
								id: id,
								title: response.data.shops[id].name,
								zipcode: zipcode
							})
						}

						self.updateMaps();
					}
				});
			}
		} else {
			if(delayed_timeout === true) {
				setTimeout(function() {
					self.updateMapsPickupPoints(false);
				}, (delay+1)*1000);
			}
		}
	}

	updateMaps() {
		if(gMap !== false) {
			google.maps.event.clearListeners(gMap, 'bounds_changed');
			gMap.clearMarkers();
		}

		for (var i = 0; i < gLocations.length; i++) {
			this.getLocationPosition(gLocations[i], i * 200, function (location) {
				if (location.hasOwnProperty('position')) {
					var pos = location.position;

					if (gMap === false) {
						gMap = new google.maps.Map(document.getElementById('gls-shipping-map'), {
							zoom: 10,
							center: pos,
							mapTypeId: google.maps.MapTypeId.ROADMAP
						});
					} else {
						gMap.setCenter(pos);
					}

					var marker = new google.maps.Marker({
						position: pos,
						map: gMap,
						parcelShopName: location.title,
						parcelShopAddress: location.address,
						parcelShopID: location.id
					});

					google.maps.event.addListener(marker, 'click', (function (marker, i) {
						return function () {
							gInfowindow.setContent('<p><strong>' + marker.parcelShopName + '</strong></p> <br> <p>' + marker.parcelShopAddress + '</p> <br> <a class="maps-parcelshop-chooser" data-id="' + marker.parcelShopID + '" style="background:#2c3e50; color: #FFF; padding: 10px 15px; border-radius: 3px; font-weight: 600; display: inline-block; cursor: pointer;">Vælg pakkeshop</a>');
							gInfowindow.open(gMap, marker);
						}
					})(marker, i));

					gMarkers.push(marker);
				}
			});
		}
	}

	getLocationPosition(location, timeout, cb) {
		var data = {
			address: location.address,
			componentRestrictions: {
				postalCode: location.zipcode
			}
		};
		var geocoder = new google.maps.Geocoder();
		setTimeout(function() {
			geocoder.geocode(
				data,
				function (results, status) {
					if (status === google.maps.GeocoderStatus.OK && Array.isArray(results) && results.length > 0) {
						location.position = {
							lat: results[0].geometry.location.lat(),
							lng: results[0].geometry.location.lng()
						};
					} else {
						console.log('Geocode was not successful for the following reason: ', status, data);
					}

					cb(location);
				}
			);
		}, timeout);
	}

	checkGoogleMapsSearchButtonStatus() {
		var address = $('#shipping-modal input#address').val();
		var button = $(document).find('#shipping-modal #btn-search');
		var zipcode = $('#shipping-modal input#zipcode').val();

		if(
			address !== undefined &&
			address !== null &&
			address.length > 0 &&
			zipcode !== undefined &&
			zipcode !== null &&
			zipcode.length === 4
		) {
			button.prop('disabled', false);
		} else {
			button.prop('disabled', true);
		}
	}

	updateSelectedPickupPoint(selecter) {
		$('#gls_chosen_parcelshop').val(selecter.val()).trigger('change');


		$('#gls_chosen_pickup_point .name').text(selecter.data('name'));
		$('#gls_chosen_pickup_point .address').text(selecter.data('address'));

		var data = {
			action: 'select_pickup_point',
			pickup_point_id: $('#gls_chosen_parcelshop').val(),
		};

		$.post(main_theme_objects.ajax_url, data, function(response) {
			if(response.hasOwnProperty('success') && response.success) {
			}
		});
	}

	getShippinAddress() {
		if($('input[name="ship_to_different_address"]').is(':checked')) {
			return {
				'country': $('select[name="shipping_country"] option:selected').val(),
				'zipcode': $('input[name="shipping_postcode"]').val(),
				'address': $('input[name="shipping_address_1"]').val()
			}
		} else {
			return {
				'country': $('select[name="billing_country"] option:selected').val(),
				'zipcode': $('input[name="billing_postcode"]').val(),
				'address': $('input[name="billing_address_1"]').val()
			}
		}
	}

	updatePickupPoints() {
		$('#gls-parcel-picker-wrapper').addClass('loading');

		var address = this.getShippinAddress();

		var data = {
			action: 'update_pickup_points',
			country: address.country,
			zipcode: address.zipcode,
			address: address.address,
		};

		$.post(main_theme_objects.ajax_url, data, function(response) {
			if(response.hasOwnProperty('success') && response.success) {
				$('#gls-parcel-picker').html(response.data.html);
				$('#gls-parcel-picker-wrapper').removeClass('loading');
			}
		});
	}
}


// WEBPACK FOOTER //
// ./resources/js/modules/_pickup-point-picker.js